module.exports = __webpack_public_path__ + "fonts/d399cbfa-b9be-47ac-983c-3600c2684bb2.fe3d8bcd.ttf";